module.exports = __webpack_public_path__ + "img/9791191826012.14768e51.jpg";